import { cast, Instance, types } from 'mobx-state-tree';
import { BOTTOM_SHEET_DEFAULT_VALUES, BOTTOM_SHEET_VIEWS } from './bottomSheet.constants';
import { ILookupModel, LookupModel } from '../_models/lookup';
import { ViewStyle } from 'react-native';
import { BoxStyleInfo, FormatInfo } from '@photosi/expo-photosi-sdk/build/PrintUtils';

export type BottomSheetInstance = Instance<typeof BottomSheet>;

export const BottomSheet = types
  .model({
    bottomSheetVisible: types.boolean,
    bottomSheetTitle: types.string,
    bottomSheetView: types.enumeration(Object.values(BOTTOM_SHEET_VIEWS)),
    bottomSheetLookupsSecondLevel: types.array(LookupModel),
    bottomSheetLookup: types.safeReference(LookupModel),
    isSecondLevelLookup: types.boolean,
    bottomSheetData: types.frozen(),
    showOpacityBackground: types.boolean,
    showDragIndicator: types.boolean,
    contentViewStyle: types.frozen(),
  })
  .volatile<{
    suggestedFormatCard: (FormatInfo | BoxStyleInfo) & { title: string };
    onPressDiscardChanges: () => void;
    onPressSaveChanges: () => void;
    uploadButtonCallback: (params: { fileIds: string[] }) => void;
  }>(self => ({
    onPressDiscardChanges: () => {},
    onPressSaveChanges: () => {},
    uploadButtonCallback: () => {},
    suggestedFormatCard: BOTTOM_SHEET_DEFAULT_VALUES.suggestedFormatCard,
  }))
  .actions(self => {
    return {
      openBottomSheet: (options: {
        bottomSheetView?: BOTTOM_SHEET_VIEWS;
        showOpacityBackground?: boolean;
        showDragIndicator?: boolean;
        isSecondLevelLookup?: boolean;
        bottomSheetTitle?: string;
        bottomSheetLookupsSecondLevel?: ILookupModel[];
        bottomSheetData?: any;
        onPressSaveChanges?: () => void;
        onPressDiscardChanges?: () => void;
        bottomSheetLookup?: ILookupModel;
        contentViewStyle?: ViewStyle;
        uploadButtonCallback?: () => void;
        suggestedFormatCard?: (FormatInfo | BoxStyleInfo) & { title: string };
      }) => {
        self.bottomSheetView = options.bottomSheetView ?? BOTTOM_SHEET_DEFAULT_VALUES.bottomSheetView;

        self.showOpacityBackground = options.showOpacityBackground ?? BOTTOM_SHEET_DEFAULT_VALUES.showOpacityBackground;

        self.showDragIndicator = options.showDragIndicator ?? BOTTOM_SHEET_DEFAULT_VALUES.showDragIndicator;

        self.isSecondLevelLookup = options.isSecondLevelLookup ?? BOTTOM_SHEET_DEFAULT_VALUES.isSecondLevelLookup;

        self.bottomSheetTitle = options.bottomSheetTitle ?? BOTTOM_SHEET_DEFAULT_VALUES.bottomSheetTitle;

        self.bottomSheetLookupsSecondLevel = cast(
          options.bottomSheetLookupsSecondLevel ?? BOTTOM_SHEET_DEFAULT_VALUES.bottomSheetLookupsSecondLevel,
        );

        self.bottomSheetData = options.bottomSheetData ?? BOTTOM_SHEET_DEFAULT_VALUES.bottomSheetData;

        self.bottomSheetLookup = options.bottomSheetLookup;

        self.contentViewStyle = options.contentViewStyle ?? BOTTOM_SHEET_DEFAULT_VALUES.contentViewStyle;

        self.suggestedFormatCard = options.suggestedFormatCard ?? BOTTOM_SHEET_DEFAULT_VALUES.suggestedFormatCard;

        self.onPressSaveChanges = options.onPressSaveChanges ?? (() => {});

        self.onPressDiscardChanges = options.onPressDiscardChanges ?? (() => {});

        self.uploadButtonCallback = options.uploadButtonCallback ?? (() => {});

        self.bottomSheetVisible = true;
      },
      closeBottomSheet: () => {
        self.bottomSheetVisible = false;
      },
      removeBottomSheetLookup: () => {
        self.bottomSheetLookup = undefined;
      },
    };
  });
